// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.external-site {
  display: inline-block;
  margin-left: 5px;
  text-decoration: none;
  vertical-align: top;
  line-height: 0.9;
  color: #fff;
}

.desktopAlinment {
  padding-left: 90px !important;
}

.global-footer {
  padding-left: 80px !important;
}

.fmenu {
  padding-bottom: 20px;
}
.fmenu img {
  height: 12px;
}
.fmenu li {
  float: left;
}
.fmenu .policy {
  margin-left: -14px;
}
.fmenu span {
  padding-right: 2px;
}

.flex-column a span {
  font-size: 16px;
  padding-right: 4px;
}

@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.global-footer-fn {
  background: #191919;
  border-top: 4px solid #ea7400;
  padding-top: 0;
  padding-bottom: 30px;
  color: white;
}
.global-footer-fn a:focus {
  outline-color: white;
}
.global-footer-fn .fn-footer-line {
  padding-top: 35px;
}
.global-footer-fn .icon-social-youtubeL {
  width: auto;
  padding-right: 11px !important;
}
.global-footer-fn .footer-nav img {
  height: 20px;
}
.global-footer-fn .fn-social {
  padding-right: 300px;
}
.global-footer-fn .social-nav {
  padding: 0px 54px 15px;
}
.global-footer-fn .social-nav i {
  padding-right: 50px;
}
.global-footer-fn .social-nav img {
  height: 20px;
}
.global-footer-fn .copy-right {
  text-decoration-style: dotted;
}
.global-footer-fn .first-col li:first-child, .global-footer-fn .second-col li:first-child {
  padding-top: 20px;
}
.global-footer-fn .footer-nav li, .global-footer-fn .social-nav li {
  padding: 17.5px 0;
}
.global-footer-fn .first-col li:last-child {
  padding-bottom: 10px;
}
.global-footer-fn .second-col li:last-child {
  padding-bottom: 10px;
}
.global-footer-fn .second-col {
  padding-left: 30px;
}
.global-footer-fn p {
  margin: 0;
}
.global-footer-fn .right-border::after {
  background: #959595;
  right: 0;
}

@media (max-width: 1024px) {
  .allright-text {
    clear: both;
  }
}
@media (max-width: 1024px) {
  .global-footer {
    padding-left: 0px !important;
  }
  .desktopAlinment {
    padding-left: 0px !important;
  }
  .global-footer-fn {
    padding: 0;
  }
  .global-footer-fn h2 {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .global-footer-fn .second-col {
    padding-left: 10px;
  }
  .global-footer-fn .allright-text {
    font-size: 11px;
    padding-bottom: 30px;
  }
  .global-footer-fn .first-col li:first-child {
    padding-top: 20px;
  }
  .global-footer-fn .fmenu {
    margin: 0;
    padding: 5px 0 15px;
  }
  .global-footer-fn .fmenu img {
    height: 17px;
  }
  .global-footer-fn .fmenu li {
    font-size: 16px;
    padding: 15px 0;
  }
  .global-footer-fn .footer-nav img {
    height: 20px;
  }
  .global-footer-fn .footer-nav li {
    padding: 15px 0;
  }
  .global-footer-fn .second-col li:last-child {
    padding-bottom: 20px;
  }
  .global-footer-fn .social-nav {
    padding: 20px 0;
    border-top: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/footer/footer.component.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACF,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AACA;;AAEA;EACE,6BAAA;AACF;;AACA;EACE,6BAAA;AAEF;;AAAA;EAKI,oBAAA;AADJ;AAFE;EACE,YAAA;AAIJ;AADI;EACI,WAAA;AAGR;AADG;EACK,kBAAA;AAGR;AADI;EAEE,kBAAA;AAEN;;AAMA;EAEI,eAAA;EACA,kBAAA;AAJJ;;ACZI;EA4BA;IACE,YClDE;EFsCN;ECWE;IACE,aClDE;EFyCN;ECQE;IACE,UClDE;EF4CN;ECKE;IACE,aClDE;EF+CN;ECEE;IACE,aClDE;EFkDN;ECDE;IACE,UClDE;EFqDN;ECJE;IACE,aClDE;EFwDN;ECPE;IACE,aClDE;EF2DN;ECVE;IACE,UClDE;EF8DN;ECbE;IACE,aClDE;EFiEN;EChBE;IACE,aClDE;EFoEN;ECnBE;IACE,WClDE;EFuEN;ECjBE;IACE,kBCvDE;EF0EN;ECpBE;IACE,mBCvDE;EF6EN;ECvBE;IACE,gBCvDE;EFgFN;EC1BE;IACE,mBCvDE;EFmFN;EC7BE;IACE,mBCvDE;EFsFN;EChCE;IACE,gBCvDE;EFyFN;ECnCE;IACE,mBCvDE;EF4FN;ECtCE;IACE,mBCvDE;EF+FN;ECzCE;IACE,gBCvDE;EFkGN;EC5CE;IACE,mBCvDE;EFqGN;EC/CE;IACE,mBCvDE;EFwGN;EClDE;IACE,iBCvDE;EF2GN;AACF;ACnFI;EAoCA;IACE,YC9DE;EFgHN;ECnDE;IACE,aC9DE;EFmHN;ECtDE;IACE,UC9DE;EFsHN;ECzDE;IACE,aC9DE;EFyHN;EC5DE;IACE,aC9DE;EF4HN;EC/DE;IACE,UC9DE;EF+HN;EClEE;IACE,aC9DE;EFkIN;ECrEE;IACE,aC9DE;EFqIN;ECxEE;IACE,UC9DE;EFwIN;EC3EE;IACE,aC9DE;EF2IN;EC9EE;IACE,aC9DE;EF8IN;ECjFE;IACE,WC9DE;EFiJN;EC/EE;IACE,kBCnEE;EFoJN;EClFE;IACE,mBCnEE;EFuJN;ECrFE;IACE,gBCnEE;EF0JN;ECxFE;IACE,mBCnEE;EF6JN;EC3FE;IACE,mBCnEE;EFgKN;EC9FE;IACE,gBCnEE;EFmKN;ECjGE;IACE,mBCnEE;EFsKN;ECpGE;IACE,mBCnEE;EFyKN;ECvGE;IACE,gBCnEE;EF4KN;EC1GE;IACE,mBCnEE;EF+KN;EC7GE;IACE,mBCnEE;EFkLN;EChHE;IACE,iBCnEE;EFqLN;AACF;AA7IA;EACE,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;AA+IF;AA7II;EACE,oBAAA;AA+IN;AA5IE;EACE,iBAAA;AA8IJ;AA5IE;EACE,WAAA;EACA,8BAAA;AA8IJ;AA3II;EACE,YAAA;AA6IN;AA1IE;EACE,oBAAA;AA4IJ;AAzIE;EACE,sBAAA;AA2IJ;AA1II;EACE,mBAAA;AA4IN;AA1II;EACE,YAAA;AA4IN;AAvIE;EACE,6BAAA;AAyIJ;AAtIE;EACE,iBAAA;AAwIJ;AArIE;EACE,iBAAA;AAuIJ;AApIE;EACE,oBAAA;AAsIJ;AAnIE;EACE,oBAAA;AAqIJ;AAlIE;EACE,kBAAA;AAoIJ;AAjIE;EACE,SAAA;AAmIJ;AAhIE;EACE,mBAAA;EACA,QAAA;AAkIJ;;AC1NI;ED8FF;IACE,WAAA;EAgIF;AACF;AChOI;EDuGF;IACE,4BAAA;EA4HF;EA1HE;IACE,4BAAA;EA4HJ;EAzHA;IAKE,UAAA;EAuHF;EA3HE;IACE,gBAAA;IACA,mBAAA;EA6HJ;EA1HE;IACE,kBAAA;EA4HJ;EA1HE;IACE,eAAA;IACA,oBAAA;EA4HJ;EAzHE;IACE,iBAAA;EA2HJ;EAxHE;IAIE,SAAA;IACA,mBAAA;EAuHJ;EA3HI;IACE,YAAA;EA6HN;EAxHI;IACE,eAAA;IACA,eAAA;EA0HN;EArHE;IACE,YAAA;EAuHJ;EArHE;IACE,eAAA;EAuHJ;EAnHE;IACE,oBAAA;EAqHJ;EAlHE;IACE,eAAA;IACA,gBAAA;EAoHJ;AACF","sourcesContent":[".external-site{\n  display: inline-block;\nmargin-left: 5px;\ntext-decoration: none;\nvertical-align: top;\nline-height: .9;\ncolor: #fff;\n}\n\n.desktopAlinment{\n  padding-left: 90px !important;\n}\n.global-footer {\n  padding-left: 80px !important;}\n\n.fmenu {\n \n  img{\n    height: 12px\n  }\n    padding-bottom: 20px;\n    li{\n        float: left;\n    }\n   .policy {\n        margin-left: -14px;\n    }\n    span\n    {\n      padding-right: 2px;\n    }\n}\n\n// .allright-text{\n//     clear:both;\n// }\n\n.flex-column a span {\n    // font-family: 'Omnes-ATT-W02-medium', Arial;\n    font-size: 16px;\n    padding-right: 4px;\n}\n@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.global-footer-fn {\n  background: #191919;\n  border-top: 4px solid color(primary, base);\n  padding-top: 0;\n  padding-bottom: 30px;\n  color: color(default, light);\n  a{\n    &:focus {\n      outline-color: color(default, light);\n    }\n  }\n  .fn-footer-line{\n    padding-top: 35px;\n  }\n  .icon-social-youtubeL{\n    width: auto;\n    padding-right: 11px !important;\n  }\n  .footer-nav { \n    img{\n      height: 20px;\n    }\n  } \n  .fn-social{\n    padding-right:300px;\n  }\n\n  .social-nav{\n    padding: 0px 54px 15px;\n    i{\n      padding-right : 50px;\n    }\n    img{\n      height: 20px;\n    }\n    \n  }\n\n  .copy-right {\n    text-decoration-style: dotted;\n  }\n\n  .first-col li:first-child, .second-col li:first-child {\n    padding-top: 20px;\n  }\n\n  .footer-nav li,.social-nav li {\n    padding: 17.5px 0;\n  }\n\n  .first-col li:last-child {\n    padding-bottom: 10px;\n  }\n\n  .second-col li:last-child {\n    padding-bottom: 10px;\n  }\n\n  .second-col {\n    padding-left: 30px;\n  }\n\n  p {\n    margin: 0;\n  }\n\n  .right-border::after {\n    background: color(inverse, lighter);\n    right: 0;\n    // height: 127px;\n  }\n}\n\n@include respond-to(small){\n  .allright-text{\n    clear: both;\n  }\n}\n\n\n\n\n@include respond-to(small) {\n  .global-footer {\n    padding-left: 0px !important;}\n\n    .desktopAlinment{\n      padding-left: 0px !important;\n    }\n  \n  .global-footer-fn {\n    h2{\n      margin-top: 15px;\n      margin-bottom: 15px;\n    }\n    padding: 0;\n    .second-col {\n      padding-left: 10px;\n    }\n    .allright-text {\n      font-size: 11px;\n      padding-bottom: 30px;\n    }\n\n    .first-col li:first-child {\n      padding-top: 20px;\n    }\n\n    .fmenu {\n      img{\n        height:17px;\n      }\n      margin: 0;\n      padding: 5px 0 15px;\n\n      li{\n        font-size: 16px;\n        padding: 15px 0; \n      }\n    }\n\n    .footer-nav { \n    img{\n      height: 20px;\n    }\n    li {\n      padding: 15px 0;\n    }\n  }\n\n    .second-col li:last-child {\n      padding-bottom: 20px;\n    }\n\n    .social-nav {\n      padding: 20px 0;\n      border-top: none;\n      // border-bottom: 1px solid color(inverse, dark);\n    }\n\n  }\n}","@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
